export default __webpack_public_path__ + "static/media/1856.53ec2599.png";